import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Input, Button, Icon, Alert, Row, Col, message, Switch } from 'antd';
import Ink from 'react-ink';


import {
  schoolInsert,
  schoolUpdate
} from '../../../modules/school';

const FormItem = Form.Item;

class SchoolListDetails extends Component {
	constructor(props){
		super(props);
		this.state = {
			loading: false,
			message: null
		}
	}

  componentDidUpdate(prevProps) {
    const { selected } = this.props;
    if (prevProps.selected !== selected && !selected) {
      this.props.form.resetFields();
    }
  }
	
	handleSubmit = e => {
		e.preventDefault();

		const { data } = this.props;

		this.props.form.validateFields((err, values) => {
			if (!err) {
				this.setState({ loading: true });

        values.status = !values.status ? 'active' : "inactive";

				if (!this.props.data) {
					this.props.schoolInsert(values).then( 
						(res) => {
							message.success('成功新增學校!');
							this.setState({ loading: false, message: null });
							this.props.form.resetFields();
							this.props.callback();
						},
						(err) => {
							this.setState({ loading: false, message: `Can't get through. Please make sure input is valid or contact the administrator.` }); 
						}
					);
				}
				else {
				
				this.props.schoolUpdate(values, data._id).then( 
					(res) => {
						message.success('成功編輯學校!');
						this.setState({ loading: false, message: null });
						this.props.callback();
					},
					(err) => {
						this.setState({ loading: false, message: `Can't get through. Please try again later or contact the administrator.` }); 
					}
				);
			}
			}
		});
	}

	render() {
		
		const { loading, message } = this.state;
		const { getFieldDecorator } = this.props.form;

		const { data } = this.props;
		
		return (
			<Form onSubmit={this.handleSubmit} className="ownForm">
				{ (message) ? <Alert message={message} type="error" style={{ marginBottom: '20px' }} showIcon /> : ""}

				<FormItem
					label="英文名稱"
				>
					{ getFieldDecorator('name_en', {
						rules: [ { required: true, message: '請輸入英文名稱！' } ],
						initialValue: (data && data.name_en) ? data.name_en : ""
					})(
					<Input />
					)}
				</FormItem>

        <FormItem
					label="中文名稱"
				>
					{ getFieldDecorator('name_tc', {
						rules: [ { required: true, message: '請輸入中文名稱！' } ],
						initialValue: (data && data.name_tc) ? data.name_tc : ""
					})(
					<Input />
					)}
				</FormItem>

        <FormItem
					label="凍結學校"
				>
					{ getFieldDecorator('status', {
						initialValue: (data && data.status) ? data.status === 'inactive' : false
					})( 
					<Switch />
					)}
				</FormItem>

				<FormItem 
					className="noMarginBtm"
				>
					<Button type="primary" htmlType="submit" disabled={loading} style={{ width: '100%' }}><Ink /><Icon type="arrow-right" /> 提交</Button>
				</FormItem>
			</Form>
		);
	}
}

const WrappedSchoolListDetailsModal  = Form.create()(SchoolListDetails);

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch =>
bindActionCreators(
	{
		schoolInsert,
		schoolUpdate
	},
	dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(WrappedSchoolListDetailsModal);